import * as React from 'react';

// PACKAGES
import { Link, useHistory } from 'react-router-dom';

// COMPONENTS
import Button from './Button';

// ICONS
import { ReactComponent as MainLogo } from '../assets/img/logo-main.svg';
import { ReactComponent as ArrowLeft } from '../assets/svg/arrow-left.svg';

// TYPES
interface PageNameType {
	title?: string;
	text?: string;
	showBack?: boolean;
	showLogo?: boolean;
}

const PageName: React.FC<PageNameType> = ({ title = '', text = '', showBack = false, showLogo = false }) => {
	const history = useHistory();

	const goBack = () => {
		history.goBack();

		window.scrollTo(0, 0);
	};

	return (
		<>
			{(!!title || showBack || showLogo) && (
				<div className="page-heading">
					{showLogo && (
						<Link to="/">
							<MainLogo className="logo" />
						</Link>
					)}

					{showBack && (
						<Button className="btn-text-icon" onClick={goBack} buttonIcon={<ArrowLeft className="link-icon" />}>
							Back
						</Button>
					)}

					{!!title && <h1 className="h1">{title}</h1>}
				</div>
			)}

			{!!text && <p className="sub-grey-text">{text}</p>}
		</>
	);
};

export default PageName;
